// Text folding shared by the index builder (server) and the search engine (browser):
// both sides must produce the same tokens, or a query never meets the indexed word.

// Letters NFD does not decompose into a base letter and a combining mark.
// Apostrophes join a word ("пам'ять", "driver's") instead of splitting it.
const FOLDED_LETTERS: Record<string, string> = { ł: 'l', ß: 'ss', æ: 'ae', ø: 'o', œ: 'oe', ʼ: '', '’': '', "'": '' };
// Cyrillic in Latin letters (Ukrainian national transliteration, simplified), so a query typed in
// either script meets the other: Ukrainian pages write "PESEL", "PKK" or "WORD" in Latin letters.
// Applied after the diacritics are gone (й → и, ї → і).
// "w" and "v" fold to one letter: Cyrillic "в" stands for both ("ворд" → WORD, "вроцлав" → Wrocław).
const CYRILLIC_TO_LATIN: Record<string, string> = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'h',
    ґ: 'g',
    д: 'd',
    е: 'e',
    є: 'ie',
    ж: 'zh',
    з: 'z',
    и: 'y',
    і: 'i',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'kh',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ь: '',
    ю: 'iu',
    я: 'ia',
    ы: 'y',
    э: 'e',
    ъ: '',
};
const COMBINING_MARKS = /\p{M}+/gu;
const WORD = /[\p{L}\p{N}]+/gu;

/** Lower case without diacritics, Cyrillic in Latin letters, "w" as "v": "Łódź" → "lodz", "Їжак" → "izhak". */
export function foldText(text: string): string {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(COMBINING_MARKS, '')
        .replace(/[łßæøœʼ’']/g, (letter) => FOLDED_LETTERS[letter])
        .replace(/[а-яєіґ]/g, (letter) => CYRILLIC_TO_LATIN[letter])
        .replace(/w/g, 'v');
}

/** Folded words of a text, in order, repeats included. */
export function searchTokens(text: string): string[] {
    return foldText(text).match(WORD) ?? [];
}
